import { Component, OnInit, Input, OnDestroy, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { faBars } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  @Input('heading') public title: string = '';
  public isDesktopCollapsed = false;
  public isMobileOpen = false;
  public isMobile = false;
  public faBars = faBars;
  private subscription: Subscription = new Subscription();

  get sidebarCollapsed(): boolean {
    return this.isMobile ? false : this.isDesktopCollapsed;
  }

  constructor() { }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  ngOnInit() {
    this.checkScreenSize();
    this.loadSavedState();

    // Listen for storage changes to sync states
    const storageListener = (e: StorageEvent) => {
      if (e.key === 'desktopSidebarCollapsed' && e.newValue !== null) {
        this.isDesktopCollapsed = JSON.parse(e.newValue);
      }
      if (e.key === 'mobileSidebarOpen' && e.newValue !== null) {
        this.isMobileOpen = JSON.parse(e.newValue);
      }
    };
    
    window.addEventListener('storage', storageListener);
    
    // Listen for manual checks for same-tab updates
    const intervalId = setInterval(() => {
      const desktopState = localStorage.getItem('desktopSidebarCollapsed');
      if (desktopState !== null) {
        const parsedDesktopState = JSON.parse(desktopState);
        if (parsedDesktopState !== this.isDesktopCollapsed) {
          this.isDesktopCollapsed = parsedDesktopState;
        }
      }
      
      const mobileState = localStorage.getItem('mobileSidebarOpen');
      if (mobileState !== null) {
        const parsedMobileState = JSON.parse(mobileState);
        if (parsedMobileState !== this.isMobileOpen) {
          this.isMobileOpen = parsedMobileState;
        }
      }
    }, 100);

    // Cleanup
    this.subscription.add(() => {
      window.removeEventListener('storage', storageListener);
      clearInterval(intervalId);
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private checkScreenSize(): void {
    this.isMobile = window.innerWidth <= 768;
  }

  private loadSavedState(): void {
    // Load desktop state
    const desktopState = localStorage.getItem('desktopSidebarCollapsed');
    if (desktopState !== null) {
      this.isDesktopCollapsed = JSON.parse(desktopState);
    }

    // Load mobile state
    const mobileState = localStorage.getItem('mobileSidebarOpen');
    if (mobileState !== null) {
      this.isMobileOpen = JSON.parse(mobileState);
    }
  }

  /**
   * Toggle mobile sidebar - on mobile devices, this shows/hides the sidebar overlay
   */
  toggleMobileSidebar(): void {
    if (this.isMobile) {
      this.isMobileOpen = !this.isMobileOpen;
      localStorage.setItem('mobileSidebarOpen', JSON.stringify(this.isMobileOpen));
      
      // Dispatch custom event to notify sidebar component
      window.dispatchEvent(new CustomEvent('mobileToggleSidebar', {
        detail: { open: this.isMobileOpen }
      }));
    }
  }

}
